import DOMPurify from 'dompurify'
import {useEffect, useState} from "react";
import {useRouter} from "next/router";
import HNClientInstance, {IStoryWithAllComments} from "../../util/HnClient";
import Link from "next/link";
import {IComment} from '../../util/HnClient'
import Comment from "../../components/Comment";
import {timeFromNow} from "../../util/TimeUtil";


const Item = () => {
  const [requested, setRequested] = useState(false)
  const [story, setStory] = useState<IStoryWithAllComments>()
  const router = useRouter()
  const {id} = router.query
  const client = HNClientInstance
  useEffect(() => {
    if (!id) {
      return;
    }
    client.fullyLoadStory(id).then(setStory)
    // @ts-ignore
    // client.getKids(id).then(setComments)
  }, [id])


  const title = story?.title
  const score = story?.score

  if (!story) {
    return <div>Loading</div>
  }

  return (<div>



    <Link href='/'>Home</Link>
    <div>
      <h1>{title}</h1>
      <div>{story.score} points by {story.by} {timeFromNow(story.time)}</div>
      <div className="storyText" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(story.text)}}></div>
    </div>

    <hr/>

    <div className="commentsContainer">
      {story?.loadedKids?.length && story.loadedKids.map(comment => {
        return (
              <Comment key={comment.id} comment={comment}/>
        )
      })}
    </div>

    <div></div>

    <br/><br/><br/>
    <hr/>
    <hr/>
    {/*<div>*/}
    {/*  {JSON.stringify(comments)}*/}
    {/*</div>*/}

  </div>)
}

export default Item